import React, { useEffect, useState } from "react";
import AgendaPromoBanner from "../agenda/AgendaPromoBanner";

function getMentorshipAds() {
  try {
    const ads = JSON.parse(localStorage.getItem("mr_home_data"))?.ads?.mentor_left;
    return Array.isArray(ads) ? ads : [];
  } catch {
    return [];
  }
}

function hasHomeDataLoaded() {
  return localStorage.getItem("mr_home_data") !== null;
}

export function MentorshipAdCardShimmer() {
  return <AgendaPromoBanner ads={[]} loading />;
}

function MentorshipAdCard() {
  const [dataReady, setDataReady] = useState(hasHomeDataLoaded);
  const [ads, setAds] = useState(getMentorshipAds);

  useEffect(() => {
    const syncAds = () => {
      setAds(getMentorshipAds());
      setDataReady(hasHomeDataLoaded());
    };

    window.addEventListener("mrHomeDataUpdated", syncAds);
    return () => window.removeEventListener("mrHomeDataUpdated", syncAds);
  }, []);

  return <AgendaPromoBanner ads={ads} loading={!dataReady} />;
}

export default React.memo(MentorshipAdCard);
